module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "new-users-charges-type"
  }, [_c('button', {
    class: {
      'active': _vm.userData.typeUser === 1
    },
    on: {
      "click": function($event) {
        _vm.setTypeUser(1)
      }
    }
  }, [_c('div', {
    staticClass: "img-superviser"
  }), _vm._v(" "), _c('span', [_vm._v("Supervisor")])]), _vm._v(" "), _c('button', {
    class: {
      'active': _vm.userData.typeUser === 0
    },
    on: {
      "click": function($event) {
        _vm.setTypeUser(0)
      }
    }
  }, [_c('div', {
    staticClass: "img-housemaid"
  }), _vm._v(" "), _c('span', [_vm._v("Mucama")])])]), _vm._v(" "), _c('div', {
    staticClass: "new-users-text"
  }, [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("But I must explain to you how all this mistaken idea of denouncing pleasure and praising pain was born and I will give you a complete account of the system, and expound the actual teachings of the great explorer of the truth, the master-builder of human happiness. No one rejects, dislikes, or avoids pleasure itself, because it is pleasure, but because those who do not know how to pursue pleasure rationally encounter consequences that are extremely painful.")])])], 1)], 1), _vm._v(" "), _c('form', {
    staticClass: "new-users-form",
    attrs: {
      "action": ""
    }
  }, [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md10": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [_c('label', {
    staticClass: "new-users-header",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Nombres")]), _vm._v(" "), _c('input-text', {
    attrs: {
      "label": _vm.namePlaceholder,
      "value": _vm.userData.name,
      "required": true
    },
    on: {
      "input": _vm.setName
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [_c('label', {
    staticClass: "new-users-header",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Apellidos")]), _vm._v(" "), _c('input-text', {
    attrs: {
      "label": _vm.lastNamePlaceholder,
      "value": _vm.userData.lastName,
      "required": true
    },
    on: {
      "input": _vm.setLastName
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [_c('label', {
    staticClass: "new-users-header",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Fecha de nacimiento")]), _vm._v(" "), _c('input-text', {
    attrs: {
      "label": _vm.bornDate.placeholder,
      "type": _vm.bornDate.type,
      "value": _vm.userData.bornDate,
      "required": true
    },
    on: {
      "input": _vm.setBornDate
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md10": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [_c('select-button', {
    attrs: {
      "label": _vm.genderLabel,
      "items": _vm.genders
    },
    on: {
      "parent-value": _vm.setGender
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [_c('label', {
    staticClass: "new-users-header",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Correo electrónico")]), _vm._v(" "), _c('input-text', {
    attrs: {
      "label": _vm.email.placeholder,
      "type": _vm.email.type,
      "value": _vm.userData.email,
      "required": true
    },
    on: {
      "input": _vm.setEmail
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [_c('label', {
    staticClass: "new-users-header",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Confirmar correo electrónico")]), _vm._v(" "), _c('input-text', {
    attrs: {
      "label": _vm.confirmEmail.placeholder,
      "type": _vm.confirmEmail.type,
      "value": _vm.userData.confirmEmail
    },
    on: {
      "input": _vm.setConfirmEmail
    }
  }), _vm._v(" "), (_vm.confirmEmail.noMatch) ? _c('small', {
    staticClass: "new-users-password"
  }, [_vm._v("No coinciden los correos electrónicos.")]) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md10": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [_c('label', {
    staticClass: "new-users-header",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Contraseña actual")]), _vm._v(" "), _c('input-text', {
    attrs: {
      "type": _vm.password.type,
      "disabled": _vm.password.disabledPassword,
      "value": _vm.userData.password,
      "required": true
    },
    on: {
      "input": _vm.setCurrentPassword
    }
  }), _vm._v(" "), (_vm.password.currentNoMatch) ? _c('small', {
    staticClass: "new-users-password"
  }, [_vm._v("La contraseña introducida no coincide con la registrada.")]) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [_c('label', {
    staticClass: "new-users-header",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Nueva contraseña")]), _vm._v(" "), _c('input-text', {
    attrs: {
      "type": _vm.password.type,
      "disabled": _vm.password.disabledNewPassword
    },
    on: {
      "input": _vm.setNewPassword
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [_c('label', {
    staticClass: "new-users-header",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Repetir contraseña")]), _vm._v(" "), _c('input-text', {
    attrs: {
      "type": _vm.password.type,
      "disabled": _vm.password.disabledNewPassword
    },
    on: {
      "input": _vm.setConfirmPassword
    }
  }), _vm._v(" "), (_vm.password.noMatch) ? _c('small', {
    staticClass: "new-users-password"
  }, [_vm._v("No coinciden las contraseñas.")]) : _vm._e(), _vm._v(" "), (_vm.password.required) ? _c('small', {
    staticClass: "new-users-password"
  }, [_vm._v("Debe confirmar la nueva contraseña.")]) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md10": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md12": ""
    }
  }, [_c('label', {
    staticClass: "new-users-header",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Seleccione las sucursales")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md2": ""
    }
  }, [_c('v-checkbox', {
    staticClass: "input-checkbox",
    attrs: {
      "label": "Seleccione todas",
      "hide-details": ""
    },
    on: {
      "change": _vm.selectAllBranchOffices
    },
    model: {
      value: (_vm.allBranchOffice),
      callback: function($$v) {
        _vm.allBranchOffice = $$v
      },
      expression: "allBranchOffice"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.branchOffices), function(branchOffice) {
    return _c('v-flex', {
      key: branchOffice.id,
      staticClass: "new-users-branch-offices"
    }, [_c('v-checkbox', {
      staticClass: "input-checkbox",
      attrs: {
        "label": branchOffice.name,
        "value": branchOffice.id,
        "hide-details": ""
      },
      model: {
        value: (_vm.userData.branchOffices),
        callback: function($$v) {
          _vm.userData.branchOffices = $$v
        },
        expression: "userData.branchOffices"
      }
    })], 1)
  }))], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md8": ""
    }
  }, [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": "",
      "mb-0": ""
    }
  }, [_c('label', {
    staticClass: "new-users-header",
    staticStyle: {
      "margin-bottom": "0"
    },
    attrs: {
      "for": ""
    }
  }, [_vm._v("Foto de perfil")])])], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "new-user-file-upload"
  }, [_c('file-upload-container', {
    attrs: {
      "label-for": 'Foto-perfil',
      "image-url": _vm.userData.imageUrl
    },
    on: {
      "upload": _vm.load
    }
  })], 1)])], 1)], 1)], 1), _vm._v(" "), _c('v-layout', [_c('button', {
    staticClass: "new-users-save",
    attrs: {
      "disabled": _vm.activeSaveButton
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.save($event)
      }
    }
  }, [_vm._v("Guardar\n\t\t\t")])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "new-users-header"
  }, [_c('span', [_vm._v("Cargo del Usuario")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-534df40a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/housekeeping/users/Create.vue
// module id = 1638
// module chunks = 8